import React from 'react';
import Image from './icon.png';
import BackgroundImage from './BackgroundIcon.jpg';
import './TestIon.css';

const TestIcon: React.FC = () => {
  const containerStyle: React.CSSProperties = {
    width: '100vh',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    position: 'relative',
    // 
    borderRadius: '0px',
  };

  const backgroundImageStyle: React.CSSProperties = {
    position: 'absolute',
    width: '100vh',
    height: '100vh',
    objectFit: 'contain',
    maxWidth: '100%',
    zIndex: 0,
    opacity: 0.05,
  };

  const coverViewStyle: React.CSSProperties = {
    position: 'absolute',
    width: '100vh',
    height: '100vh',
    objectFit: 'contain',
    maxWidth: '100%',
    zIndex: 1,
    opacity: 1,
  };

  const imageStyle: React.CSSProperties = {
    position: 'absolute',
    // width: '245vh',
    // height: '245vh',
    width: '210vh',
    height: '210vh',
    objectFit: 'fill',
    transform: 'translateY(13vh)',
    zIndex: 2,
  };

  const gradientViewStyle: React.CSSProperties = {
    position: 'absolute',
    width: '100vh',
    height: '100vh',
    objectFit: 'contain',
    maxWidth: '100%',
    opacity: 1,
    //
    // 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //
    //
    // background: "linear-gradient(0deg, rgba(32, 147, 255, .15), rgba(252, 68, 33, .15))",
    filter: 'blur(1px)',
    zIndex: 10,
  };

  return (
    <div style={containerStyle} className='icon-test'>
        {/* <img src={BackgroundImage} alt="Test Icon" style={backgroundImageStyle} /> */}
        {/* <div style={coverViewStyle} className='cover-view-style'/> */}

        <div style={gradientViewStyle} className='linear-gradient-style'>
            <img src={ Image } alt="Test Icon" style={ imageStyle } />
        </div>
        {/*  */}
        {/* <div style={{
            position: 'absolute',
            width: '100vh',
            height: '100vh',
            objectFit: 'fill',
            background: "linear-gradient(0deg, rgba(32, 147, 255, .305), rgba(252, 68, 33, .305))",
            mixBlendMode: 'luminosity',
            zIndex: 200,
        }} className='cover-view-style'/> */}
        {/*  */}
    </div>
  );
};

export default TestIcon;